const translations = {
    "Motif": "Reason",
    "Sous-Motif": "Sub-Reason",
    "Description": "Description",
    "Civilité": "Salutation",
    "Nom": "Last Name",
    "Prénom": "First Name",
    "Email": "Email",
    "Téléphone": "Phone",
    "Société": "Company",
    "Adresse": "Address",
    "Code postal": "Postal Code",
    "Ville": "City",
    "Pays": "Country",
    "Madame": "Ms.",
    "Monsieur": "Mr.",
    "Livraison à l'étranger": "International Delivery",
    "Points de vente à l'étranger": "International Sales Points",
    "Cadeaux & Entreprises": "Gifts & Businesses",
    "Commande": "Order",
    "Compte Client": "Customer Account",
    "Franchisés & Partenaires": "Franchisees & Partners",
    "International": "International",
    "Les produits": "The products",
    "Livraison": "Delivery",
    "« Les informations recueillies font l’objet d’un traitement informatique destiné à la bonne prise en compte et au suivi de votre commande. Ces données seront exclusivement utilisées par FAUCHON Paris dans le cadre du traitement de votre demande. Conformément à la loi « informatique et libertés » du 6 janvier 1978 modifiée en 2004, vous bénéficiez d’un droit d’accès et de rectification aux informations qui vous concernent, que vous pouvez exercer en vous adressant à FAUCHON Paris, Service Web, 8 rue volney, 75002 PARIS. Vous pouvez également, pour des motifs légitimes, vous opposer au traitement des données vous concernant. »": "The information collected is processed electronically for the purpose of processing and tracking your order. This data will be used exclusively by FAUCHON Paris to process your request. In accordance with the French Data Protection Act of 6 January 1978, amended in 2004, you have the right to access and rectify information concerning you, which you may exercise by contacting FAUCHON Paris, Service Web, 8 rue volney, 75002 PARIS. You may also, for legitimate reasons, object to the processing of data concerning you",
    "Pièces jointes": "Attachments",
    "ENVOYER VOTRE DEMANDE": "SUBMIT YOUR REQUEST",
    "* champs obligatoires": "* compulsory fields",
    "Offres en cours": "Current offers",
    "Presse & Communication": "Press & Communication",
    "Réseaux sociaux & Partenariats": "Social Media & Partnerships",
    "Ressources Humaines": "Human Resources",
    "AFGHANISTAN": "AFGHANISTAN",
    "AFRIQUE DU SUD": "SOUTH AFRICA",
    "ALBANIE": "ALBANIA",
    "ALGERIE": "ALGERIA",
    "ALLEMAGNE": "GERMANY",
    "ANDORRE": "ANDORRA",
    "ANGOLA": "ANGOLA",
    "ANGUILLA": "ANGUILLA",
    "ANTARCTIQUE": "ANTARCTICA",
    "ANTIGUA ET BARBUDA": "ANTIGUA AND BARBUDA",
    "ANTILLES NEERLANDAISES": "NETHERLANDS ANTILLES",
    "ARABIE SAOUDITE": "SAUDI ARABIA",
    "ARGENTINE": "ARGENTINA",
    "ARMENIE": "ARMENIA",
    "ARUBA": "ARUBA",
    "AUSTRALIE": "AUSTRALIA",
    "AUTRICHE": "AUSTRIA",
    "AZERBAIDJAN": "AZERBAIJAN",
    "BAHAMAS": "BAHAMAS",
    "BAHREIN": "BAHRAIN",
    "BANGLADESH": "BANGLADESH",
    "BARBADE": "BARBADOS",
    "BELGIQUE": "BELGIUM",
    "BELIZE": "BELIZE",
    "BENIN": "BENIN",
    "BERMUDES": "BERMUDA",
    "BHOUTAN": "BHUTAN",
    "BIELORUSSIE": "BELARUS",
    "BIRMANIE (MYANMAR)": "MYANMAR",
    "BOLIVIE": "BOLIVIA",
    "BONAIRE, SAINT-EUSTACHE, SABA": "BONAIRE, SAINT-EUSTACE, SABA",
    "BOSNIE-HERZEGOVINE": "BOSNIA AND HERZEGOVINA",
    "BOTSWANA": "BOTSWANA",
    "BRESIL": "BRAZIL",
    "BRUNEI": "BRUNEI",
    "BULGARIE": "BULGARIA",
    "BURKINA FASO": "BURKINA FASO",
    "BURUNDI": "BURUNDI",
    "CAMBODGE": "CAMBODIA",
    "CAMEROUN": "CAMEROON",
    "CANADA": "CANADA",
    "CAP VERT": "CAPE VERDE",
    "CHILI": "CHILE",
    "CHINE": "CHINA",
    "CHYPRE": "CYPRUS",
    "COLOMBIE": "COLOMBIA",
    "CONGO": "CONGO",
    "COREE DU NORD": "NORTH KOREA",
    "COREE DU SUD": "SOUTH KOREA",
    "COSTA RICA": "COSTA RICA",
    "COTE D'IVOIRE": "IVORY COAST",
    "CROATIE": "CROATIA",
    "CUBA": "CUBA",
    "CURAÇAO": "CURACAO",
    "DANEMARK": "DENMARK",
    "DJIBOUTI": "DJIBOUTI",
    "DOMINIQUE": "DOMINICA",
    "EGYPTE": "EGYPT",
    "EMIRATS ARABES UNIS (EAU)": "UNITED ARAB EMIRATES",
    "EQUATEUR": "ECUADOR",
    "ERYTHREE": "ERITREA",
    "ESPAGNE": "SPAIN",
    "ESTONIE": "ESTONIA",
    "ETATS-UNIS": "UNITED STATES",
    "ETHIOPIE": "ETHIOPIA",
    "FIDJI": "FIJI",
    "FINLANDE": "FINLAND",
    "FRANCE": "FRANCE",
    "GABON": "GABON",
    "GAMBIE": "GAMBIA",
    "GEORGIE": "GEORGIA",
    "GEORGIE SUD/ILES SANDWICH SUD": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
    "GHANA": "GHANA",
    "GIBRALTAR": "GIBRALTAR",
    "GRECE": "GREECE",
    "GRENADE": "GRENADA",
    "GROENLAND": "GREENLAND",
    "GUADELOUPE": "GUADELOUPE",
    "GUAM": "GUAM",
    "GUATEMALA": "GUATEMALA",
    "GUENERSEY": "GUERNSEY",
    "GUINEE": "GUINEA",
    "GUINEE EQUATORIALE": "EQUATORIAL GUINEA",
    "GUINEE-BISSAU": "GUINEA-BISSAU",
    "GUYANA": "GUYANA",
    "GUYANE FRANCAISE": "FRENCH GUIANA",
    "HAITI": "HAITI",
    "HONDURAS": "HONDURAS",
    "HONG-KONG": "HONG KONG",
    "HONGRIE": "HUNGARY",
    "ILE ALAND": "ÅLAND ISLANDS",
    "ILE BOUVET": "BOUVET ISLAND",
    "ILE CHRISTMAS": "CHRISTMAS ISLAND",
    "ILE DE LA REUNION": "REUNION",
    "ILE DE L'ASCENSION": "ASCENSION ISLAND",
    "ILE DE MAN": "ISLE OF MAN",
    "ILE MAURICE": "MAURITIUS",
    "ILES CAIMANS": "CAYMAN ISLANDS",
    "ILES COCOS (KEELING)": "COCOS (KEELING) ISLANDS",
    "ILES COOK": "COOK ISLANDS",
    "ILES FALKLAND": "FALKLAND ISLANDS",
    "ILES FEROE": "FAROE ISLANDS",
    "ILES HEARD ET MCDONALD": "HEARD ISLAND AND MCDONALD ISLANDS",
    "ILES MARIANNES DU NORD": "NORTHERN MARIANA ISLANDS",
    "ILES MARSHALL": "MARSHALL ISLANDS",
    "ILES MINEURES ELOIGNEES E.-U.": "UNITED STATES MINOR OUTLYING ISLANDS",
    "ILES NORFOLK": "NORFOLK ISLAND",
    "ILES PITCAIRN": "PITCAIRN ISLANDS",
    "ILES SALOMON": "SOLOMON ISLANDS",
    "ILES TURKS ET CAICOS": "TURKS AND CAICOS ISLANDS",
    "ILES VIERGES (E.U.)": "U.S. VIRGIN ISLANDS",
    "ILES VIERGES (R.U.)": "BRITISH VIRGIN ISLANDS",
    "INDE": "INDIA",
    "INDONESIE": "INDONESIA",
    "IRAK": "IRAQ",
    "IRAN": "IRAN",
    "IRLANDE": "IRELAND",
    "ISLANDE": "ICELAND",
    "ISRAEL": "ISRAEL",
    "ITALIE": "ITALY",
    "JAMAIQUE": "JAMAICA",
    "JAPON": "JAPAN",
    "JERSEY": "JERSEY",
    "JORDANIE": "JORDAN",
    "KAZAKHSTAN": "KAZAKHSTAN",
    "KENYA": "KENYA",
    "KIRGHIZISTAN": "KYRGYZSTAN",
    "KIRIBATI": "KIRIBATI",
    "KOWEIT": "KUWAIT",
    "LAOS": "LAOS",
    "LES COMORES": "COMOROS",
    "LESOTHO": "LESOTHO",
    "LETTONIE": "LATVIA",
    "LIBAN": "LEBANON",
    "LIBERIA": "LIBERIA",
    "LIBYE": "LIBYA",
    "LIECHTENSTEIN": "LIECHTENSTEIN",
    "LITUANIE": "LITHUANIA",
    "LUXEMBOURG": "LUXEMBOURG",
    "MACAO": "MACAO",
    "MACEDOINE": "NORTH MACEDONIA",
    "MADAGASCAR": "MADAGASCAR",
    "MALAWI": "MALAWI",
    "MALAYSIE": "MALAYSIA",
    "MALDIVES": "MALDIVES",
    "MALI": "MALI",
    "MALTE": "MALTA",
    "MAROC": "MOROCCO",
    "MARTINIQUE": "MARTINIQUE",
    "MAURITANIE": "MAURITANIA",
    "MAYOTTE": "MAYOTTE",
    "MEXIQUE": "MEXICO",
    "MICRONESIE": "MICRONESIA",
    "MOLDAVIE": "MOLDOVA",
    "MONACO": "MONACO",
    "MONGOLIE": "MONGOLIA",
    "MONTENEGRO": "MONTENEGRO",
    "MONTSERRAT": "MONTSERRAT",
    "MARTEAU (LES)": "THE MARTEAU",
    "NAURU": "NAURU",
    "NAYORO": "NAYORO",
    "NIGER": "NIGER",
    "NIGERIA": "NIGERIA",
    "NIUE": "NIUE",
    "NORVEGE": "NORWAY",
    "NOUVELLE-CALEDONIE": "NEW CALEDONIA",
    "NOUVELLE-ZELANDE": "NEW ZEALAND",
    "OMAN": "OMAN",
    "OUGANDA": "UGANDA",
    "OUI": "YES",
    "PAKISTAN": "PAKISTAN",
    "PALAOS": "PALAU",
    "PANAMA": "PANAMA",
    "PAPOUASIE-NOUVELLE-GUINEE": "PAPUA NEW GUINEA",
    "PARAGUAY": "PARAGUAY",
    "PAYS-BAS": "NETHERLANDS",
    "PAYS DE GALLES": "WALES",
    "PELOPE": "PELOPE",
    "PEROU": "PERU",
    "PHILIPPINES": "PHILIPPINES",
    "POLYNESIE FRANCAISE": "FRENCH POLYNESIA",
    "PORTUGAL": "PORTUGAL",
    "QATAR": "QATAR",
    "ROUMANIE": "ROMANIA",
    "RUSSIE": "RUSSIA",
    "RWANDA": "RWANDA",
    "SAINT-HELENE": "SAINT HELENA",
    "SAINT-KITTS-ET-NEVIS": "SAINT KITTS AND NEVIS",
    "SAINT-MARIN": "SAN MARINO",
    "SAINT-MARTIN (PARTIE FRANCAISE)": "SAINT MARTIN (FRENCH PART)",
    "SAINT-PIERRE-ET-MIQUELON": "SAINT PIERRE AND MIQUELON",
    "SAINT-SIAGAN": "SAINT SIAGAN",
    "SAINT-THEODORE": "SAINT THEODORE",
    "SAINT-TOURMALET": "SAINT TOURMALET",
    "SENEGAL": "SENEGAL",
    "SERBIE": "SERBIA",
    "SEYCHELLES": "SEYCHELLES",
    "SINGAPOUR": "SINGAPORE",
    "SLOVAQUIE": "SLOVAKIA",
    "SLOVENIE": "SLOVENIA",
    "SOLOMON ISLANDS": "SOLOMON ISLANDS",
    "SOMALIE": "SOMALIA",
    "SRI LANKA": "SRI LANKA",
    "SUEDE": "SWEDEN",
    "SUISSE": "SWITZERLAND",
    "SVALBARD ET JAN MAYEN": "SVALBARD AND JAN MAYEN",
    "SYRIE": "SYRIA",
    "TADJIKISTAN": "TAJIKISTAN",
    "TAIWAN": "TAIWAN",
    "TANZANIE": "TANZANIA",
    "TCHAD": "CHAD",
    "THAILANDE": "THAILAND",
    "TIMOR-LESTE": "EAST TIMOR",
    "TOGO": "TOGO",
    "TONGA": "TONGA",
    "TRINIDAD-ET-TOBAGO": "TRINIDAD AND TOBAGO",
    "TUNISIE": "TUNISIA",
    "TURKMENISTAN": "TURKMENISTAN",
    "TURQUIE": "TURKEY",
    "TUVALU": "TUVALU",
    "UKRAINE": "UKRAINE",
    "URUGUAY": "URUGUAY",
    "VATICAN": "VATICAN",
    "VENEZUELA": "VENEZUELA",
    "VIETNAM": "VIETNAM",
    "YEMEN": "YEMEN",
    "ZAMBIE": "ZAMBIA",
    "ZIMBABWE": "ZIMBABWE",
    "Demande d'informations": "Information request",
    "Réclamations Cadeaux d'affaires": "Claims Business gifts",
    "Annulation de commande": "Order cancellation",
    "Commande Click & Collect": "Click & Collect order",
    "Demande de facture": "Invoice request",
    "Demande de remboursement": "Refund request",
    "Demande d'informations paiement": "Payment information request",
    "Difficultés lors de la prise de commande": "Order placement difficulties",
    "Modification de commande": "Order modification",
    "Paiement - Problème": "Payment issue",
    "Produit endommagé": "Damaged product",
    "Produit manquant": "Missing product",
    "Connexion": "Login",
    "Inscription à la Newsletter": "Newsletter subscription",
    "Programme de fidélité": "Loyalty program",
    "Suppression de compte": "Account deletion",
    "Demande d'informations produit": "Product information request",
    "Disponibilité produit": "Product availability",
    "Fournisseurs": "Suppliers",
    "Problème qualité": "Quality issue",
    "Demande d'informations livraison": "Delivery information request",
    "Réclamation livraison": "Delivery complaint",
    "Retard de livraison": "Delivery delay",
    "Code avantage - Probléme d'utilisation": "Discount code - Usage issue",
    "Généralités & conditions promo": "General & promotional terms",
    "Demande de partenariat": "Partnership request",
    "Informations": "Information",
    "Contact Ecole": "School contact",
    "Recrutement": "Recruitment"
};

function translatePage() {
    document.getElementById('easiformarea').querySelectorAll('label, button, .mandatoryfieldmention, .additionnalInformation').forEach(element => {
        let text = element.innerText.trim();
        console.log(text)
        if (translations[text]) {
            element.innerText = translations[text];
        }
    });

    document.querySelector('.validatebutton').innerHTML = 'SUBMIT YOUR REQUEST';

    document.getElementById('easiformarea').querySelectorAll('select').forEach(selectElement => {
        let labelText = selectElement.getAttribute('label');
        if (labelText && translations[labelText]) {
            selectElement.setAttribute('label', translations[labelText]);
        }

        selectElement.querySelectorAll('option').forEach(optionElement => {
            let optionLabel = optionElement.getAttribute('label');
            if (optionLabel && translations[optionLabel]) {
                optionElement.setAttribute('label', translations[optionLabel]);
            }
        });
    });
}

if (window.location.pathname.startsWith("/en")) {
    setTimeout(function() {
        translatePage();

        document.getElementById('fld_Category').addEventListener('change', function() {
            translatePage();
        });
    }, 1000);
}